import React, { useState } from "react";
import { register } from "../../helper/sso";
import { ErrorText } from "../shared/FeedbackText";
import Image from "next/image";
import { getCoopUrl, getTermsUrl, getDataUrl } from "../../helper/url";

export type NavigationProps = {
  toggleOverlay?: Function;
  setUser: any;
};

function isValid(myString) {
  return /(?=.*[^A-Za-z0-9])(?=.*\d).{8,}/.test(myString);
}

export default function Logo(props: NavigationProps) {
  const [userName, setUserName] = useState("");
  const [checkbox, setCheckbox] = useState(false);
  const [success, setSuccess] = useState(false);
  const [errors, setErrors] = useState<any>(); //{userName: null, password: null, global: null}

  const clickRegister = async () => {
    if (!userName) {
      setSuccess(false);
      setErrors({ userName: "Die E-Mail muss ausgefüllt sein" });
    } else if (!checkbox) {
      setSuccess(false);
      setErrors({
        checkbox: "Die Nutzungsbedingungnen müssen akzeptiert werden.",
      });
    } else {
      const data = await register(userName);
      if (data && data.error == "") {
        setSuccess(true);
        setErrors({});
        // data.user.decoded = data.decoded;
        // props.setUser(data.user);
      } else {
        setSuccess(false);
        setErrors({ global: data.error });
      }
    }
  };

  return (
    <React.Fragment>
      <div className="user-login flex flex-col space-y-4 p-6 py-8">
        {success ? (
          <div>
            <h1 className="mb-4 font-lato text-xl">
              Überprüfen Sie Ihren Posteingang
            </h1>
            <div className="mb-8 space-y-3">
              <p>
                Vielen Dank. Ihr Benutzeraccount wurde erstellt. Um ihn zu
                verifizieren, ist noch ein kleiner Schritt nötig:
              </p>
              <p>
                Sie haben eine E-Mail zur Aktivierung Ihres Benutzerkontos
                erhalten.
              </p>
              <p>Bitte prüfen Sie Ihren Posteingang.</p>
            </div>
            <div className="">
              <button
                type="button"
                onClick={(e) => {
                  e.preventDefault();
                  props.toggleOverlay?.();
                }}
                className="btn btn-light"
              >
                Registrierung schließen
              </button>
            </div>
            {success}
          </div>
        ) : (
          <React.Fragment>
            <h1 className="mb-4 text-center font-lato text-xl">
              Registrieren Sie sich hier:
            </h1>
            <form className="form space-y-4">
              {errors && errors.global && <ErrorText role="alert" tabIndex="-1" id="global-error">{errors.global}</ErrorText>}
              <div className="form-field">
                <label htmlFor="register-name">E-Mail *</label>
                <input
                  id="register-name"
                  onChange={(e) => {
                    setUserName(e.target.value);
                  }}
                  type="text"
                  placeholder="E-Mail"
                />
                {errors?.userName && (
                  <ErrorText className="mb-1" role="alert">{errors.userName}</ErrorText>
                )}
              </div>
              <div>
                <div className="form-checkbox">
                  <input
                    className="form-checkbox__input"
                    id="register-checkbox"
                    onChange={(e) => {
                      setCheckbox(e.target.checked);
                    }}
                    type="checkbox"
                    required
                  />
                  <label
                    htmlFor="register-checkbox"
                    className="form-checkbox__label"
                  >
                    Ich habe die{" "}
                    <a
                      className="text-highlighted"
                      href={getTermsUrl()}
                      target="_blank"
                      rel="noreferrer"
                    >
                      Nutzungsbedingungen
                    </a>{" "}
                    gelesen und akzeptiere sie. *
                  </label>
                </div>
                {errors?.checkbox && (
                <ErrorText className="mt-1" role="alert" id="checkbox-error">{errors.checkbox}</ErrorText>
                )}
              </div>
              <div className="flex flex-col space-y-4 text-xs">
                <span>
                  Hier finden Sie die Hinweise zum{" "}
                  <a
                    className="link text-highlighted"
                    href={getDataUrl()}
                    target="_blank"
                    rel="noreferrer"
                  >
                    Datenschutz
                  </a>
                  .
                </span>
                <span>
                  * Bitte füllen Sie alle Pflichtfelder aus, um die
                  Registrierung abzuschließen.
                </span>
                <span>
                  Sie haben bereits einen Account?{" "}
                  <button
                    type="button"
                    onClick={(e) => {
                      e.preventDefault();
                      props.toggleOverlay?.();
                    }}
                    className="link text-highlighted"
                  >
                    Jetzt anmelden
                  </button>
                  !
                </span>
                <div className="flex">
                  <div className="mr-2">
                    {" "}
                    <Image
                      src="/images/logo-vnp.png"
                      width="63"
                      height="32"
                      alt="Logo VNP"
                      className="max-w-none"
                    />
                  </div>
                  Mit der Registrierung erstellen Sie einen VNP-Account, der für
                  alle Produkte des Verlags Nürnberger Presse gültig ist.
                </div>
              </div>
              <div className="flex flex-col space-y-2 items-center justify-center">
                <button
                  type="submit"
                  onClick={(e) => {
                    e.preventDefault();
                    clickRegister();
                  }}
                  className="btn btn-primary"
                >
                  Jetzt registrieren
                </button>
              </div>
            </form>
          </React.Fragment>
        )}
      </div>
    </React.Fragment>
  );
}
